import { BookOpen } from 'lucide-react';
import type { KatalogTreffer } from '@/types/bestellung';

/**
 * Der Katalog-Hinweis über der Trefferliste (K4).
 *
 * Steht im Suchfeld eine Katalognummer, sagt diese Zeile, welcher Titel
 * das ist und in welchem Katalog er steht. Sie ist eine AUSKUNFT neben
 * der Suche, kein Treffer: die Liste darunter zeigt weiterhin, was die
 * gewöhnliche Suche findet — die Nummer könnte ja in einer Notiz oder
 * einem Titel stehen.
 *
 * Kein Knopf, keine Aktion: erfasst wird eine Bestellung im
 * Erfassungsformular, und dort löst dieselbe Nummer denselben Titel auf.
 */
export function KatalogHinweis({ treffer }: { treffer: KatalogTreffer }) {
  return (
    <div className="flex flex-wrap items-baseline gap-x-2 gap-y-0.5 border-b border-line bg-cream-warm px-4 py-2 text-sm text-ink-soft">
      <BookOpen aria-hidden className="h-4 w-4 shrink-0 self-center text-akzent" />
      <span className="tabular-nums text-ink-faint">Nr. {treffer.nummer}</span>
      <span className="font-serif text-ink">{treffer.titel}</span>
      {treffer.autor !== null && <span>{treffer.autor}</span>}
      <span className="text-ink-faint">
        {treffer.katalog_label}
        {treffer.katalogseite !== null && `, Seite ${treffer.katalogseite}`}
      </span>
      {!treffer.aktiv && (
        <span className="text-gold-dark">
          aus {treffer.katalog_label}, Preis prüfen
        </span>
      )}
    </div>
  );
}
